export const dotIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="6" width="12" height="12" rx="1" fill="currentColor"/></svg>`,
  name: 'dot' as const,
};
